import cx from 'classnames'
import type { CSSProperties } from 'react'

import { styles } from './image.styles'

import { ImageAspectRatio, ImageProps } from './image.types'

type PortraitAspectRatio = '1/1' | '3/4' | '2/3' | '9/16'

const portraitMap: Record<ImageAspectRatio, PortraitAspectRatio> = {
  '1/1': '1/1',
  '4/3': '3/4',
  '3/2': '2/3',
  '16/9': '9/16',
}

export function Image({
  src,
  alt,
  objectFit = 'cover',
  aspectRatio = '4/3',
  portrait = false,
  borderRadius = 'none',
  className = '',
  style,
  ...imgProps
}: ImageProps) {
  const resolvedAspectRatio = portrait ? portraitMap[aspectRatio] : aspectRatio
  // The consumer's style is merged last, so it can add or override a single
  // property without dropping the aspect ratio, object fit and radius.
  const imageStyle: CSSProperties = {
    ...styles.dynamic(resolvedAspectRatio, objectFit, borderRadius),
    ...style,
  }

  return (
    <img
      {...imgProps}
      src={src}
      alt={alt}
      className={cx(styles.base, className)}
      style={imageStyle}
    />
  )
}
